import React, { useEffect, useState } from 'react'
import { IoClose, IoSearch } from 'react-icons/io5';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/fala-480.png';

// Phones / tablets: the top bar of inner pages (logo + search), so products can be
// searched from anywhere in the app. White and compact like most marketplace apps;
// it searches when the person presses Enter or the button, not while they type
// (it used to jump to the results half a second into typing).
const MobileSearchInput = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchQuery, setSearchQuery] = useState<string>("");

    // On the results page, show what was searched so it can be adjusted
    useEffect(() => {
        if (location.pathname === '/search') {
            setSearchQuery(new URLSearchParams(location.search).get('query') ?? '');
        }
    }, [location.pathname, location.search]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const query = searchQuery.trim();
        if (!query) return;
        (document.activeElement as HTMLElement | null)?.blur(); // close the phone keyboard
        navigate(`/search?query=${encodeURIComponent(query)}`);
    };

    return (
        <div className="bg-white border-b border-gray-200 shadow-sm px-3 py-2">
            <div className="flex items-center gap-2.5">
                {/* hidden on very small phones (< 340px) so the search field keeps its room */}
                <Link to="/" aria-label="Accueil Falashop" className="shrink-0 max-[339px]:hidden">
                    <img src={logo} alt="Falashop" className="h-7 w-auto" />
                </Link>

                <form
                    role="search"
                    onSubmit={handleSubmit}
                    className="flex-1 min-w-0 flex items-center h-10 rounded-full bg-gray-100 pl-3 pr-1 border border-transparent focus-within:border-primary-default focus-within:bg-white transition-colors"
                >
                    <IoSearch size={18} className="shrink-0 text-content-tertiary" aria-hidden="true" />
                    {/* min-w-0: lets the field shrink on very small phones (see the 308px fix) */}
                    <input
                        // the browser's own clear button is hidden: this bar has its own (✕)
                        className="flex-1 min-w-0 bg-transparent border-none text-sm text-content-default placeholder-content-tertiary focus:outline-none px-2 [&::-webkit-search-cancel-button]:hidden"
                        type="search"
                        enterKeyHint="search"
                        placeholder="Rechercher sur Falashop"
                        aria-label="Rechercher un produit"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                        <button
                            type="button"
                            onClick={() => setSearchQuery('')}
                            aria-label="Effacer"
                            className="shrink-0 p-1 text-content-tertiary hover:text-content-default"
                        >
                            <IoClose size={18} />
                        </button>
                    )}
                    <button
                        type="submit"
                        aria-label="Rechercher"
                        className="shrink-0 flex h-8 w-8 items-center justify-center rounded-full bg-primary-default text-white active:scale-95 transition"
                    >
                        <IoSearch size={16} />
                    </button>
                </form>
            </div>
        </div>
    )
}

export default MobileSearchInput
